import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map, pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FdDetailNavSectionService {
  private activeTabIndex: number = 0;
  private isRedirectClicked: boolean = false;
 constructor(private http: HttpClient) { }

  onSaveCreateForm(payload) {
    return this.http.post(`/vd/formBuilder/createForm`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
        else {
          return null;
        }
      })
    );
  }

  getPageFormById(pageBuilderId) {
    // return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPage`).pipe(
    return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPageForm`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getInterviewRoundsById(id) { 
    return this.http.get(`/vd/formBuilder/get/${id}/fbPageFormId`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  setActiveTabIndex(index: number): void {
    this.activeTabIndex = index;
  }

  getActiveTabIndex(): number {
    return this.activeTabIndex;
  }
  setisRedirectClicked(index: boolean): void {
    this.isRedirectClicked = index;
  }

  getisRedirectClicked(): boolean {
    return this.isRedirectClicked;
  }

}


